'use strict';

angular.module('programme')

.directive('gallery', function ()
{
    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'modules/programme/editor-components/gallery/gallery.html',
        controller: 'GalleryCtrl',
        controllerAs: '$ctrl',
    };
})

.controller('GalleryCtrl', function ($scope)
{
    this.defaultSlide = {
        playerName: 'KINGSLEY COMAN',
        line1: '<strong>Club:</strong> FC Bayren',
        line2: '<strong>Age:</strong> 21 <strong>Position:</strong> Midfielder',
        image: [{type: 'image'}],
        logo: [{type: 'image'}],
        components: [
            {
                html : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at tristique mi. Pellentesque tempor, mi eget imperdiet accumsan, lorem leo imperdiet augue, accumsan tempus erat nisi sed sem. Aliquam lectus eros, rhoncus et nisl eu, pulvinar bibendum mi. Nullam quis risus dui. Nulla gravida hendrerit quam at dignissim. Pellentesque eu dictum libero. Mauris vel lorem eu sem dapibus pretium. Nunc placerat sed mauris scelerisque condimentum. Duis luctus volutpat scelerisque. Donec vitae odio vitae nunc posuere rutrum id nec lacus.",
                tag: "p",
                type: "textblock"
            },
            {
                html : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at tristique mi. Pellentesque tempor, mi eget imperdiet accumsan, lorem leo imperdiet augue, accumsan tempus erat nisi sed sem. Aliquam lectus eros, rhoncus et nisl eu, pulvinar bibendum mi. Nullam quis risus dui. Nulla gravida hendrerit quam at dignissim. Pellentesque eu dictum libero. Mauris vel lorem eu sem dapibus pretium. Nunc placerat sed mauris scelerisque condimentum. Duis luctus volutpat scelerisque. Donec vitae odio vitae nunc posuere rutrum id nec lacus.",
                tag: "p",
                type: "textblock"
            }
        ],
    };

    $scope.data.list = $scope.data.list || [];

    $scope.placeholder = 'http://placehold.it/350x400';

    $scope.images = {};

    $scope.activeSlide = 0;

    $scope.selected = null;

    this.$onInit = function ()
    {
        if (!$scope.data.list.length) {
            this.addSlide();
        }
    };

    this.addSlide = function ()
    {
        var length = $scope.data.list.length;
        if (length) {
            $scope.data.list.push(angular.copy($scope.data.list[length - 1]));
        } else {
            $scope.data.list.push(angular.copy(this.defaultSlide));
        }
    };

    $scope.destroySlide = function (slide)
    {
        var index = $scope.data.list.indexOf(slide);
        if (index === -1) {
            return;
        }

        $scope.data.list.splice(index, 1);
    };

    $scope.$on('component:focus', function ($event)
    {
        if ($event.targetScope.item) {
            this.selectSlide($event.targetScope.item);
        }
    }.bind(this));

    this.$onInit();
});
